import React from 'react';
import SkeletonBone from './SkeletonBone';
import SkeletonGallery from './SkeletonGallery';
import SkeletonAgent from './SkeletonAgent';
import './loading.css';

const SkeletonDetails = () => (
  <div className="container skeleton-details" aria-busy="true" aria-live="polite">
    <div className="skeleton-details__header">
      <SkeletonBone className="skeleton-details__title" />
      <SkeletonBone className="skeleton-details__address" />
      <SkeletonBone style={{ height: '0.85rem', width: '120px' }} />
    </div>

    <SkeletonGallery />

    <div className="skeleton-details__layout">
      <div className="skeleton-details__info">
        <SkeletonBone className="skeleton-details__price" />
        <SkeletonBone className="skeleton-details__line" />
        <SkeletonBone className="skeleton-details__line" />
        <SkeletonBone className="skeleton-details__line skeleton-details__line--short" />
        <SkeletonBone className="skeleton-details__line" />
        <SkeletonBone className="skeleton-details__line skeleton-details__line--short" />
        <div className="skeleton-details__amenities">
          {Array.from({ length: 6 }, (_, index) => (
            <SkeletonBone key={index} className="skeleton-details__amenity" />
          ))}
        </div>
      </div>
      <div className="skeleton-details__sidebar">
        <SkeletonAgent />
        <SkeletonBone style={{ height: '3rem', width: '100%' }} />
        <SkeletonBone style={{ height: '3rem', width: '100%' }} />
      </div>
    </div>
  </div>
);

export default SkeletonDetails;
